import { API } from "../api";
import { ISKUDetailResponse, ISKUPayload, ISKUResponse } from "./types";
import { ISKU } from "../../../store/skuMapping";
import { url as URL } from "../constants";
import { validateArgs } from "../utils";

export class SKUAPIService {
  constructor(private api: API) {}

  public async getAll(params: any): Promise<ISKUResponse> {
    const response = await this.api.get<ISKUResponse>(URL.SKU.base, {
      params,
    });
    return (
      response?.data ?? {
        items: [],
        paging: {
          page: 1,
          per_page: params?.limit ?? 0,
          total_items: 0,
        },
      }
    );
  }

  public async create(data: ISKUPayload): Promise<ISKU> {
    const response = await this.api.post<ISKU>(URL.SKU.base, data);
    return response?.data as ISKU;
  }

  public async update(id: string, data: Partial<ISKUPayload>): Promise<ISKU> {
    validateArgs(id);
    const response = await this.api.patch<ISKU>(`${URL.SKU.base}/${id}`, data);
    return response?.data as ISKU;
  }

  public async get(skuId: string): Promise<ISKUResponse> {
    validateArgs(skuId);
    const response = await this.api.get<ISKUResponse>(
      URL.SKU.get.replace(":skuId", skuId),
    );
    return (
      response?.data ?? {
        items: [],
        paging: {
          page: 1,
          per_page: 0,
          total_items: 0,
        },
      }
    );
  }

  public async getDetails(skuId: string) {
    validateArgs(skuId);
    const response = await this.api.get<ISKUDetailResponse>(
      URL.SKU.details.replace(":skuId", skuId),
    );
    return response?.data;
  }
}
